<template>
    <div id="footer" class="footer absolute bottom-0 w-full z-40">
        <footer class="flex flex-col items-center">
            <ul class="link-list flex w-700 flex-wrap justify-center mb-4">
                <li v-for="link in links" :key="link.id">
                    <router-link :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: link.id } }"
                        class="text-txt-gray text-xs">{{ link.name }} </router-link>
                    <span class="px-2 text-txt-gray text-xs">|</span>
                </li>
            </ul>
            <!--<p class="mb-4"><img class="w-20" src="@/assets/site-logo.svg"></p>-->
            <p class="text-txt-lightgray text-sm my-2">プラス株式会社</p>
            <p class="text-txt-lightgray text-xs mb-4">Copyright © PLUS Corporation . All Rights Reserved.</p>
        </footer>

    </div>
</template>

<script>
export default {
    name: 'footer',
    setup() {
        const links = [
            { id: 'Education', name: '教育・保育施設', class: 'border-theme-Education hover:bg-theme-Education' },
            { id: 'Medical', name: '医療・福祉施設', class: 'border-theme-Medical hover:bg-theme-Medical' },
            { id: 'Desk', name: 'デスク・デスク周辺', class: 'border-theme-Desk hover:bg-theme-Desk' },
            { id: 'Chair', name: 'チェア', class: 'border-theme-Chair hover:bg-theme-Chair' },
            { id: 'Storage', name: '収納', class: 'border-theme-Storage hover:bg-theme-Storage' },
            { id: 'Partition', name: 'パーティション', class: 'border-theme-Partition hover:bg-theme-Partition' },
            { id: 'Counter', name: 'カウンター', class: 'border-theme-Counter hover:bg-theme-Counter' },
            { id: 'Table', name: 'テーブル', class: 'border-theme-Table hover:bg-theme-Table' },
            { id: 'MeetingChair', name: 'ミーティング チェア', class: 'border-theme-MeetingChair hover:bg-theme-MeetingChair' },
            { id: 'Lobby', name: '応接・ロビー', class: 'border-theme-Lobby hover:bg-theme-Lobby' },
            { id: 'Board', name: 'ボード', class: 'border-theme-Board hover:bg-theme-Board' },
            { id: 'Accessory', name: 'アクセサリー', class: 'border-theme-Accessory hover:bg-theme-Accessory' },
            { id: 'Outlet', name: 'アウトレット セール', class: 'border-theme-Outlet hover:bg-theme-Outlet' },
            // { id: 'Prevention', name: '感染対策用品', class: 'border-theme-Prevention hover:bg-theme-Prevention' },
            // { id: 'Emergency', name: '防災用品', class: 'border-theme-Emergency hover:bg-theme-Emergency' },

        ]

        // const route = useRoute()
        // let category_param = ''
        // const getParam = () => {
        //     category_param = ref(route.query.category_name)
        //     console.log(category_param.value)
        // }

        return {
            links,
            //   category_param,
            //   getParam
        }
    },
}

</script>